import { createSlice } from "@reduxjs/toolkit";
import { getAllSupportRequests, updateSupportRequestStatus } from "../thunks/supportRequestThunks";
import SupportLogs from "../../pages/LandLord/SupportLogs";

const supportRequestSlice = createSlice({
  name: "supportRequest",
  initialState: {
    supportLogs: {
      logs: [],
      pagination: {},
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAllSupportRequests.fulfilled, (state, action) => {
      state.supportLogs.logs = action.payload.data?.data || [];
      state.supportLogs.pagination = action.payload.data?.pagination || {};
    });
    builder.addCase(updateSupportRequestStatus.fulfilled, (state, action) => {
      const { _id, status } = action.payload.data;
      const existingRequest = state.supportLogs.logs.find(
        (req) => req._id === _id
      );    
      if (existingRequest) {
        existingRequest.status = status;
      }
    });
  },
});

export default supportRequestSlice.reducer;
